import React from 'react';
import Route from './Routes';
import './assets/scss/themes.scss';
import SocketContextProvider from './context/SocketContext';

function App() {
  return (
    <React.Fragment>
      <SocketContextProvider>
        <Route />
      </SocketContextProvider>
    </React.Fragment>
  );
}

export default App;
